export default __webpack_public_path__ + "components/01-components/media-text/media-text.html.twig";